<template>
  <div id="wrapper" :class="toggle">
    <div id="sidebar-wrapper">
      <ul class="sidebar-nav">
        <li class="sidebar-brand">
          <router-link to="/">
            <img height="28" :src="logo" />
          </router-link>
        </li>
        <li>
          <BotDropDown :bot="bot" :bots="bots" @change="changeBot($event)"></BotDropDown>
        </li>
        <li>
          <a href="#" @click="show = 'about'; toggle = null">ABOUT</a>
        </li>
        <li>
          <a href="#" @click="show = 'current plan'; toggle = null">CURRENT PLAN</a>
        </li>
        <li>
          <a href="#" @click="show = 'admins'; toggle = null">ADMINS</a>
        </li>
        <li>
          <a href="#" @click="show = 'prime members'; toggle = null">PRIME MEMBERS</a>
        </li>
        <li>
          <a href="#" @click="show = 'subscribers'; toggle = null">SUBSCRIBERS</a>
        </li>
        <li>
          <a href="#" @click="show = 'referrals'; toggle = null">REFERRALS</a>
        </li>
        <li>
          <a href="#" @click="show = 'settings'; toggle = null">SETTINGS</a>
        </li>
        <li>
          <a href="#" @click="show = 'messages'; toggle = null">MESSAGES</a>
        </li>
        <li>
          <a href="#" @click="show = 'stored data'; toggle = null">STORED DATA</a>
        </li>
        <li>
          <a href="#" @click="show = 'chats joined'; toggle = null">CHATS JOINED</a>
        </li>
        <li>
          <a href="#" @click="show = 'broadcast'; toggle = null">BROADCAST</a>
        </li>
      </ul>
    </div>
    <div class="page-content-wrapper">
      <div class="container-fluid">
        <div class="row mb-2 border-bottom border-info">
          <div class="col-xs-2">
            <a class="btn btn-link p-2" style="font-size: 1.5rem;color: #007bff;background-color: transparent;"
              role="button" id="menu-toggle" @click="toggle = toggle == null ? 'toggled' : null">
              <i class="fa fa-bars"></i>
            </a>
          </div>
          <div class="col-xs-10">
            <h1 class="p-2">{{ show }}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <loading :active.sync="isLoading" :can-cancel="true" color="green"></loading>

            <div class="container mb-5" v-if="show == 'about'">
              <div>
                <h4>{{ bot.first_name || nameError }}</h4>
                <table class="table table-striped">
                  <tr>
                    <td>Bot Token</td>
                    <td>: </td>
                    <td>{{ bot.token }}</td>
                  </tr>
                  <tr>
                    <td>Username</td>
                    <td>: </td>
                    <td>@{{ bot.username }}</td>
                  </tr>
                  <tr>
                    <td>Debug Mode
                      <Info text="Recieve Bot's error logs" />
                    </td>
                    <td>: </td>
                    <td>
                      <ToggleSwitch :value="debug == 1" @input="toggleDebug"></ToggleSwitch>
                    </td>
                  </tr>
                  <tr>
                    <td>Allow Groups
                      <Info text="Decide if bot should reply in groups" />
                    </td>
                    <td>: </td>
                    <td>
                      <ToggleSwitch :value="allow_group == 1" @input="toggleAllowGroup"></ToggleSwitch>
                    </td>
                  </tr>
                  <tr>
                    <td>Bot Status
                      <Info text="Activate/Deactivate the bot" />
                    </td>
                    <td>: </td>
                    <td>
                      <ToggleSwitch :value="status == 1" @input="toggleBotStatus"></ToggleSwitch>
                    </td>
                  </tr>
                  <tr v-if="bot.hash">
                    <td>Leaderboard Link
                      <Info text="Public link to leaderboard" />
                    </td>: <td><a :href="'/leaderboard/' + bot.hash">https://www.thebotcreator.com/leaderboard/{{bot.hash}}</a></td>
                  </tr>
                </table>

                <div class="btn-group">
                  <router-link :to="{ name: 'editor', params: { token: token } }"
                    class="btn btn-outline-primary">Edit</router-link>
                  <a :href="'https://t.me/' + bot.username" target="blank" class="btn btn-outline-primary">Chat</a>
                </div>

              </div>

            </div>

            <div class="container mb-5" v-if="show == 'chats joined'">
              <button class="btn btn-outline-primary btn-block my-5" @click="getChatsJoined">Show Channel/Group joined by
                the bot</button>
              <ChatCard :chats="chats_joined_details" @leaveChat="leaveChat" v-if="chats_joined_details.length > 0">
              </ChatCard>
            </div>

            <div class="container mb-5" v-if="show == 'admins'">
              <Alert type="alert-info" text="All admins can use admin only commands, You can add any number of admins.">
              </Alert>
              <div class="input-group mb-3">
                <input type="text" class="form-control" v-model="newAdmin" ref="newAdmin"
                  placeholder="Telegram User Id" />
                <div class="input-group-append">
                  <button @click="addAdmin" class="btn btn-outline-success">Add Admin</button>
                </div>
              </div>
              <AdminCard :admins="adminsDetails" @deleteAdmin="deleteAdmin"></AdminCard>
            </div>

            <div class="container mb-5" v-if="show == 'prime members'">

              <PrimeMembers :token="token" :primeMembers="primeMembers" :activePM="activePM" :expiredPM="expiredPM"
                @updatePrimeMembers="updatePrimeMembers">
              </PrimeMembers>
            </div>

            <div class="container mb-5" v-if="show == 'subscribers'">
              <div class="row card-columns">
                <Card :body="subscribers_today.toString()" footer="Today"></Card>
                <Card :body="subscribers_total.toString()" footer="Total"></Card>
              </div>
              <button class="btn btn-outline-primary btn-block my-5" @click="showSubscribers">Show Subscribers</button>
              <SubscribersTable :data="subscribers" :headers="subscriber_table_header" v-if="subscribers.length > 0">
              </SubscribersTable>
            </div>

            <div class="container mb-5" v-if="show == 'referrals'">
              <button class="btn btn-outline-primary btn-block my-5" @click="showSubscribers">Show Chat Referrals</button>
              <ReferralTable :token="token" :data="subscribers" :show_reset=true @resetReferralCount="resetReferralCount"
                v-if="subscribers.length > 0"></ReferralTable>
            </div>

            <div class="container mb-5" v-if="show == 'settings'">
              <Settings :settings="settings" @updateSettings="updateSettings">
              </Settings>
            </div>

            <div class="container mb-5" v-if="show == 'broadcast'">
              <Broadcast :token="token" :user="user" :admins="admins" :chatsJoined="chats_joined" :activePM="activePM"
                :expiredPM="expiredPM">
              </Broadcast>
            </div>

            <div class="container mb-5" v-if="show == 'messages'">
              <h4>Today</h4>
              <div class="row card-columns">
                <Card :body="incoming.toString()" footer="Recieved"></Card>
                <Card :body="outgoing.toString()" footer="Sent"></Card>
                <Card :body="(incoming + outgoing).toString()" footer="Total"></Card>
              </div>
            </div>

            <div class="container mb-5" v-if="show == 'stored data'">
              <button class="btn btn-outline-primary btn-block my-5" @click="getStoredData">Show Stored Data</button>
              <StoredDataTable :data="subscribers" v-if="subscribers.length > 0"></StoredDataTable>
            </div>

            <div class="container mb-5" v-if="show == 'current plan'">
              <Plan />
            </div>

            <button @click="Refresh" class="btn btn-success btn-block">Refresh</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import Card from "@/components/Card.vue";
import SubscribersTable from "@/components/SubscribersTable.vue";
import StoredDataTable from "@/components/StoredDataTable.vue";
import ReferralTable from "@/components/ReferralTable.vue";
import AdminCard from "@/components/AdminCard.vue";
import ChatCard from "@/components/ChatCard.vue";
import Alert from "@/components/Alert.vue";
import BotDropDown from "@/components/BotDropDown.vue";
import Plan from "@/components/Plan.vue";
import PrimeMembers from "@/components/PrimeMembers.vue";
import Settings from "@/components/Settings.vue";
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import Info from "@/components/Info.vue";
import Broadcast from "@/components/Broadcast.vue";



import ApiService from "@/services/ApiService";
import TelegramService from "@/services/TelegramService";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import logo from "@/assets/img/logo-white-text.png";


export default {
  name: "dashboard",
  components: {
    AdminCard,
    Alert,
    BotDropDown,
    Broadcast,
    Card,
    ChatCard,
    Info,
    Loading,
    Plan,
    PrimeMembers,
    ReferralTable,
    Settings,
    StoredDataTable,
    SubscribersTable,
    ToggleSwitch
  },
  data: function () {
    return {
      token: this.propToken,
      toggle: null,
      logo: logo,
      show: "about",
      user: this.$store.state.user,
      isLoading: false,
      broadcast: {
        file: null,
        fileAsDataURL: null,
        msgText: "",
        to: "subscribers"
      },
      broadcast_status: { start: false, subscribers: 0, time: 0, progress: 0, success: 0, fails: 0, percentage: 0 },
      bot: {},
      bots: this.$store.state.bots,
      status: 1,
      allow_group: 1,
      debug: 1,
      nameError: null,
      newAdmin: null,
      admins: [],
      chats_joined: [],
      chats_joined_details: [],
      adminsDetails: [],
      subscribers_total: 0,
      subscribers_today: 0,
      subscribers: [],
      subscriber_table_header: ["id", "username", "first_name", "last_name", "joinedAt"],
      incoming: 0,
      outgoing: 0,
      today: "",
      primeMembers: [],
      activePM: [],
      expiredPM: [],
      settings: {},
    };
  },
  methods: {
    addAdmin() {
      if (this.newAdmin == null || this.newAdmin.trim() == "") {
        this.$refs.newAdmin.focus();
        return;
      }
      if (this.admins.includes(parseInt(this.newAdmin))) {
        this.$dialog.alert("Given User is already an Admin");
        return;
      }
      else {
        this.isLoading = true;
        TelegramService.getChat(this.token, this.newAdmin)
          .then(
            function (tele_result) {
              var admins = this.admins;
              admins.push(parseInt(this.newAdmin));
              ApiService.updateBotAdmins(this.user, this.bot.token, admins)
                .then(
                  function (result) {
                    this.admins = result.admins;
                    this.adminsDetails.push(tele_result);
                    this.newAdmin = null;
                  }.bind(this)
                )
                .catch(
                  function (response) {
                    this.$dailog.alert(response.description);
                  }.bind(this)
                );
            }.bind(this)
          )
          .catch(
            function (error) {
              this.$dialog.alert(error);
            }.bind(this)
          )
          .finally(
            function () {
              this.isLoading = false;
            }.bind(this)
          );
      }
    },

    deleteAdmin(id) {
      let admins = this.admins.filter(function (admin) {
        return admin != id;
      });
      this.isLoading = true;
      ApiService.updateBotAdmins(this.user, this.bot.token, admins)
        .then(
          function (result) {
            this.admins = result.admins;
            this.adminsDetails = this.adminsDetails.filter(function (admin) {
              return admin.id != id;
            });
          }.bind(this)
        )
        .catch(
          function (response) {
            this.$dialog.alert(response.description);
          }.bind(this)
        )
        .finally(
          function () {
            this.isLoading = false;
          }.bind(this)
        );
    },

    updatePrimeMembers(PM, activePM, expiredPM) {
      this.primeMembers = PM;
      this.activePM = activePM;
      this.expiredPM = expiredPM;
    },

    getSubscribersRecursive(user, token, lastEvaluatedKey) {
      return new Promise((resolve) => {
        ApiService.getSubscribers(user, token, lastEvaluatedKey)
          .then(
            function (result) {
              this.subscribers = this.subscribers.concat(result.Items);
              if (result.LastEvaluatedKey) {
                resolve(this.getSubscribersRecursive(user, token, result.LastEvaluatedKey));
              }
              else {
                resolve(result.Items);
              }
            }.bind(this)
          )
          .catch(
            function (response) {
              this.$dialog.alert(response.description);
            }.bind(this)
          );
      });
    },
    getSubscribers(user, token, lastEvaluatedKey) {
      this.isLoading = true;
      ApiService.getSubscribers(user, token, lastEvaluatedKey)
        .then(
          function (result) {
            this.subscribers = this.subscribers.concat(result.Items);
            if (result.LastEvaluatedKey) {
              this.getSubscribers(user, token, result.LastEvaluatedKey)
            }
          }.bind(this)
        )
        .catch(
          function (response) {
            this.$dialog.alert(response.description);
          }.bind(this)
        )
        .finally(
          function () {
            this.isLoading = false;
          }.bind(this)
        );
    },
    showSubscribers() {
      this.subscribers = [];
      this.isLoading = true;
      this.getSubscribersRecursive(this.user, this.token, null)
        .then(
          function () {
            this.isLoading = false;
          }.bind(this)
        )
        .finally(
          function () {
            this.isLoading = false;
          }.bind(this)
        );
    },

    getBot() {
      this.isLoading = true;
      ApiService.getBot(this.user, this.token)
        .then(
          function (bot) {
            this.admins = bot.admins;
            this.status = ("bot_status" in bot) ? bot.bot_status : 1;
            this.primeMembers = ("primeMembers" in bot) ? bot.primeMembers : [];
            this.settings = ("settings" in bot) ? bot.settings : {};
            this.chats_joined = ("chats_joined" in bot) ? bot.chats_joined : [];
            this.allow_group = ("allow_group" in bot) ? bot.allow_group : 1;
            this.debug = ("debug" in bot) ? bot.debug : 1;

            this.subscribers_total = ("btotal" in bot.subscribers) ? bot.subscribers.btotal : 0;
            this.subscribers_today = 0;
            this.incoming = 0;
            this.outgoing = 0;
            if (bot.subscribers.today.date == this.today)
              this.subscribers_today = bot.subscribers.today.bcount;
            if (bot.messages.today.date == this.today) {
              this.incoming = bot.messages.today.incoming;
              this.outgoing = bot.messages.today.outgoing;
            }

            //this.getChatsJoined();
            this.getAdminsDetails();
            this.getPMDetails();
          }.bind(this)
        )
        .catch(
          function (response) {
            this.$dialog.alert(response.description);
          }.bind(this)
        )
        .finally(function () {
          this.isLoading = false;
        }.bind(this))
    },

    async getAdminsDetails() {
      this.adminsDetails = []
      this.admins.forEach(item => {
        TelegramService.getChat(this.token, item)
          .then(
            function (result) {
              this.adminsDetails.push(result);
            }.bind(this)
          )
          .catch(
            function (error) {
              console.log(error);
            }.bind(this)
          );
      });
    },

    async getPMDetails() {
      this.isLoading = true;
      this.activePM = []
      this.expiredPM = []
      let now = new Date()
      this.primeMembers.forEach(item => {
        TelegramService.getChat(this.token, item.id)
          .then(
            function (result) {
              result['toDate'] = item.toDate
              if (now < new Date(item.toDate.concat(" 23:59:59"))) {
                this.activePM.push(result)
              } else {
                this.expiredPM.push(result)
              }
            }.bind(this)
          )
          .catch(
            function (error) {
              console.log(error);
            }.bind(this)
          );
      });
      this.isLoading = false;
    },

    getChatsJoined() {
      this.isLoading = true
      this.chats_joined_details = []
      this.chats_joined.forEach(async (item) => {
        TelegramService.getChat(this.token, item)
          .then(async function (result) {
            TelegramService.getChatMember(this.token, item, this.bot.id)
              .then(function (chatMember) {
                result['status'] = chatMember['status']
                this.chats_joined_details.push(result)
              }.bind(this))
              .catch(
                function (error) {
                  console.log(error);
                }.bind(this)
              );
          }.bind(this))
          .catch(
            function (error) {
              console.log(error);
            }.bind(this)
          );
      });
      this.isLoading = false
    },

    getStoredData() {
      this.subscribers = [];
      this.isLoading = true;
      this.getSubscribersRecursive(this.user, this.token, null)
        .then(
          function () {
            console.log(this.subscribers.length);
          }.bind(this)
        )
        .finally(
          function () {
            this.isLoading = false;
          }.bind(this)
        );
    },

    getMe(token) {
      TelegramService.getMe(token)
        .then(
          function (bot) {
            bot["token"] = token;
            this.bot = bot;
          }.bind(this)
        )
        .catch(
          function (error) {
            this.$dialog.alert(error);
            this.nameError = "Bot name not found";
          }.bind(this)
        );
    },

    todayDate() {
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0");
      var yy = today.getFullYear();
      today = dd + "-" + mm + "-" + yy.toString().substring(2, 4);
      this.today = today;
    },

    resetBroadcastStatus() {
      this.broadcast_status.start = false
      this.broadcast_status.subscribers = 0
      this.broadcast_status.subscribers = 0
      this.broadcast_status.progress = 0
      this.broadcast_status.success = 0
      this.broadcast_status.fails = 0
      this.broadcast_status.percentage = 0
    },

    getBots() {
      this.bots = []
      this.botTokens.forEach(getMe.bind(this))
      async function getMe(token) {
        TelegramService.getMe(token)
          .then(function (bot) {
            bot['token'] = token
            this.bots.push(bot);
          }.bind(this))
          .catch(function () {
            this.$dialog.alert("Bot not found : " + token);
          }.bind(this))
      }
    },

    getBotDetails() {
      this.isLoading = true
      ApiService.getUser(this.user)
        .then(function (result) {
          if (this.token == null) {
            this.token = result.bots[0];
          }
          this.botTokens = result.bots
          this.getBots()
          this.getMe(this.token);
          this.getBot();
          //this.getStoredData();
        }.bind(this))
        .catch(function (response) {
          this.$dialog.alert(response.description)
        }.bind(this))
        .finally(function () {
          this.isLoading = false;
        }.bind(this))
    },

    changeBot(token) {
      this.isLoading = true
      this.token = token
      this.subscribers = []
      this.storedData = []
      this.chats_joined_details = []

      this.resetBroadcastStatus()
      this.getMe(token);
      this.getBot();
      this.todayDate();

      this.isLoading = false
    },

    async leaveChat(chat_id) {
      TelegramService.leaveChat(this.bot.token, chat_id)
        .then(function () {
          this.$dialog.alert("Left Chat Success");
          this.getBot()
        }.bind(this))
        .catch(function () {
          this.$dialog.alert("Leaving Chat Failed");
        }.bind(this))
    },

    toggleBotStatus() {
      this.isLoading = true
      if (this.status == 1) { this.status = 0 } else { this.status = 1 }
      ApiService.updateBotStatus(this.user, this.bot.token, this.status)
        .then(function () {
          if (this.status == 1) {
            this.$dialog.alert("Bot is now Enabled")
          } else {
            this.$dialog.alert("Bot is now Disabled")
          }
        }.bind(this))
        .catch(function (response) {
          this.$dialog.alert(response.description)
        }.bind(this))
        .finally(function () {
          this.isLoading = false
        }.bind(this))
    },

    toggleAllowGroup() {
      this.isLoading = true
      if (this.allow_group == 1) { this.allow_group = 0 } else { this.allow_group = 1 }
      ApiService.updateBotAllowGroup(this.user, this.bot.token, this.allow_group)
        .then(function () {
          if (this.allow_group == 1) {
            this.$dialog.alert("Bot is now Enabled in Groups")
          } else {
            this.$dialog.alert("Bot is now Disabled in Groups")
          }
        }.bind(this))
        .catch(function (response) {
          this.$dialog.alert(response.description)
        }.bind(this))
        .finally(function () {
          this.isLoading = false
        }.bind(this))
    },

    toggleDebug() {
      this.isLoading = true
      if (this.debug == 1) { this.debug = 0 } else { this.debug = 1 }
      ApiService.updateBotDebug(this.user, this.bot.token, this.debug)
        .then(function () {
          if (this.debug == 1) {
            this.$dialog.alert("Debug mode enabled, you can now recieve the bot's errors")
          } else {
            this.$dialog.alert("Debug mode disabled, you can no longer recieve the bot's errors")
          }
        }.bind(this))
        .catch(function (response) {
          this.$dialog.alert(response.description)
        }.bind(this))
        .finally(function () {
          this.isLoading = false
        }.bind(this))
    },

    updateSettings(settings) {
      this.isLoading = true
      ApiService.updateBotSettings(this.user, this.bot.token, settings)
        .then(function (result) {
          this.settings = result.settings
          this.$dialog.alert("Bot Settings Updated!");
        }.bind(this))
        .catch(function (response) {
          this.$dialog.alert(response.description)
        }.bind(this))
        .finally(function () {
          this.isLoading = false
        }.bind(this))
    },

    resetReferralCount() {
      this.$dialog.confirm("Do you really want to reset the referral count ?")
        .then(function () {
          this.isLoading = true;
          this.subscribers.forEach(element => {
            if (element.referrals > 0 || ('chat_referrals' in element && Object.keys(element.chat_referrals).length !== 0)) {
              ApiService.resetReferralCount(this.user, this.token, element.id)
                .then(function () {
                  element.chat_referrals = {}
                  element.referrals = 0
                })
                .catch(function (msg) {
                  this.$dailog.alert(msg)
                }.bind(this))

            }
          });
        }.bind(this))
        .catch(function () {
          console.log("Reset referral cancelled.")
        })
        .then(function () {
          this.isLoading = false;
        }.bind(this))
    },

    Refresh() {
      this.getBot()
    },

  },

  mounted() {
    this.todayDate();
    this.getBotDetails();
  }
};
</script>
